t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <ApproveInput
        :question="$t('hazard.question')"
        :image="require('@/assets/fire.svg')"
        :selected-value="hazard"
        :clicked-callback="onSelect"
      ></ApproveInput>
      <a @click="$router.push(getPrevStepUrl(step))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ApproveInput from "../../components/ApproveInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, redirectToUnselectedStepIfAny, getPrevStepUrl, getNextStepUrl } from "@/utils/steps.js";

export default {
  name: "Hazard",
  components: { CalculatorHeading, ApproveInput },
  data() {
    return {
      step: getStepIndex("hazard"),
      getPrevStepUrl: getPrevStepUrl,
      hazard: this.$store.state.data.hazard
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateHazard"]),
    onSelect(value) {
      this.hazard = value;
      this.updateHazard(value);
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>
